import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const ActivityTimelineContainer = styled.div`
  .filterBy {
    margin-right: 8px;
    ${responsive.MOBILE`
    width: 100%;
    margin-right: 8px;
    `}
  }

  .modality {
    ${responsive.TABLET_LANDSCAPE`
      width: 190px;
    `}
    ${responsive.MOBILE`
    width: 100%;
   
    .MuiInputBase-root {
      width: auto;
      margin-right: 8px;
    }
 
    .horizontal-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }`}
  }

  .duration-picker-wrapper {
    background: ${COLORS.cirrus_black2};
    padding: 16px;
    .MuiPickersTextField-root,
    .MuiPickersInputBase-root {
      width: 100%;
      ${responsive.MOBILE`
          padding: 8px;
        `};
    }
    .go-btn-grid {
      display: flex;

      .MuiButtonBase-root {
        margin-top: auto;
      }
    }

    .date-picker {
      padding-right: 20px;
    }
  }
`;
